export default __webpack_public_path__ + "images/11e48c1fee44e77d76c45c6138e1883d.svg";